import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { ToggleService } from 'src/app/components/common/header/toggle.service';
import { VersionUpdateComponent } from 'src/app/components/common/version-update/version-update.component';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { DocRestrictionsService } from 'src/app/core/services/doc-restrictions/doc-restrictions.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { UseridealService } from 'src/app/core/services/userideal/userideal.service';
import { environment } from 'src/environments/environment';
import { AdminBirthdayNoticeComponent } from '../notice-board/admin-birthday-notice/admin-birthday-notice.component';
import { NoticeBoardService } from 'src/app/core/services/notice-board/notice-board.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
    title = 'Tagus - Material Design Angular Admin Dashboard Template';
    isToggled = false;
    private _unsubscribeAll: Subject<any> = new Subject();
    fetchedUser: any;
    showHideLoader: any = true;
    notices: any[] = [];
    currentNoticeIndex: number = 0;
    pagination_config: PaginationType = {
        size: 10,
        total: 0,
        skip: 0,
        limit: 10,
    };
    description: any;
    imagePath: any;
    noticeid: any;
    isActiveSwitchUser: boolean = false;
    activeSwitchUserDetails: any = null;


    constructor(
        public router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private _docRestrictionsService: DocRestrictionsService,
        private _localStorageService: LocalStorageService,
        private userIdleService: UseridealService,
        private _authService: AuthenticationService,
        public dialog: MatDialog,
        private _loaderService: LoaderService,
        private _noticeBoardService: NoticeBoardService,
        private _toasterService: ToasterService,
    ) {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });

        this._loaderService.setLoaderStatus$.subscribe((status) => {
            this.showHideLoader = status
        });
    }

    ngOnInit(): void {
        // delegate user
        this.isActiveSwitchUser = !!this._localStorageService.getSwitchedUserDetails();
        if (this.isActiveSwitchUser) {
            this.activeSwitchUserDetails = this._localStorageService.getSwitchedUserDetails()?.user_details;
        }
        console.log(this.isActiveSwitchUser, this.activeSwitchUserDetails);
        

        this.fetchedUser = this._localStorageService.getUser();
        this.userIdleService.init(this._authService.sessionExpiryTimeInMiniutes());
        let already_stored = JSON.parse(this._localStorageService.getKey('upload_restrictions'));
        if (!already_stored?.length) {
            this.getDocUploadRestrictions();
        }

        let updateRem = JSON.parse(localStorage.getItem('updatePopupRemindMelater')!);
        // console.log({updateRem:updateRem});
        if (!updateRem) {
            if (this.fetchedUser?.appVersion !== environment.APP_VERSION) {
                setTimeout(() => {
                    this.updateVersion();
                }, 3000); // Delay of 3 seconds (3000 milliseconds)
            }
        } else {
            const updateRemTime = moment(updateRem.time);
            const currentTime = moment();
            if (currentTime.diff(updateRemTime, 'hours') > 24) {
                localStorage.removeItem('updatePopupRemindMelater');
                if (this.fetchedUser?.appVersion !== environment.APP_VERSION) {
                    setTimeout(() => {
                        this.updateVersion();
                    }, 3000); // Delay of 3 seconds (3000 milliseconds)
                }
            }
        }
        if(this.isActiveSwitchUser == false) {
            if (this.notices && this.notices.length > 0 || this.notices) {
                setTimeout(() => {
                    this.birthDayNotification();
                }, 3000); // Delay of 3 seconds (3000 milliseconds)
            }else {
                console.log('No notices available to display.');
            }
        }
        // if (this.notices && this.notices.length > 0 || this.notices) {
        //     setTimeout(() => {
        //         this.birthDayNotification();
        //     }, 3000); // Delay of 3 seconds (3000 milliseconds)
        // }else {
        //     console.log('No notices available to display.');
        // }
        // setTimeout(() => {
        //     this.birthDayNotification();
        // }, 3000); // Delay of 3 seconds (3000 milliseconds)
    }

    toggleRightSidebarTheme() {
        this.themeService.toggleRightSidebarTheme();
    }

    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    getDocUploadRestrictions() {
        this._docRestrictionsService.getUploadDocRestrict({ skip: 0, limit: 20 })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(res => {
                let data = res?.data;
                if (data && data?.length) {
                    data = data.map(element => {
                        return {
                            module: String(element?.module).toLowerCase(),
                            size: Number(element.size),
                            extension: element?.extension
                        }
                    })
                    this._localStorageService.setKey('upload_restrictions', JSON.stringify(data));
                }
            })
    }

    // update version
    updateVersion() {
        this.dialog.open(VersionUpdateComponent, {
            width: '450px',
            enterAnimationDuration: '50ms',
            exitAnimationDuration: '100ms',
            disableClose: true,
            height: 'auto',
            panelClass: 'custom-dialog-container',
            data: {},
        });
    }

    // birthday notification
    // birthDayNotification() {
    //     this.dialog.open(AdminBirthdayNoticeComponent, {
    //         width: '450px',
    //         enterAnimationDuration: '50ms',
    //         exitAnimationDuration: '100ms',
    //         disableClose: true,
    //         height: 'auto',
    //         panelClass: 'custom-dialog-container',
    //         data: {},
    //     });
    // }

    birthDayNotification() {
        let referenceModule = 'bdayNotice,featureNotice,adminNotification';
        // let tenant = '1'
        let cUser = this._localStorageService.getUser();
        let showPopup = true;
        this._loaderService.showLoader();
        this._noticeBoardService
            .getNoticeBirthDayPopup(referenceModule, cUser?.jobRoleId, showPopup, this.pagination_config)
            .subscribe((res) => {
                // console.log(res);
                const notices = res?.data?.data;

                if (notices && notices.length > 0) {
                    // Store all notices in a class property
                    this.notices = notices.slice(0, 3); // Get only the first three notices
                    this.currentNoticeIndex = 0;
                    this.showNextNotice();
                } else {
                    console.warn('No notices available to display.');
                    // this._toasterService.showError('Notice', 'No notices available at the moment.');
                }
                this._loaderService.hideLoader();
            });
    }

    showNextNotice() {
        if (this.currentNoticeIndex < this.notices.length) {
            const notice = this.notices[this.currentNoticeIndex];

            this.title = notice?.title;
            this.description = notice?.description;
            this.imagePath = notice?.imagePath;
            this.noticeid = notice?.id;

            const dialogRef = this.dialog.open(AdminBirthdayNoticeComponent, {
                width: '60%',
                enterAnimationDuration: '500ms',
                exitAnimationDuration: '500ms',
                disableClose: true,
                panelClass: 'custom-dialog-container',
                data: {
                    notice_title: this.title,
                    notice_description: this.description,
                    imagePath: this.imagePath,
                    noticeid: this.noticeid,
                    currentIndex: this.currentNoticeIndex,
                    totalNotices: this.notices.length
                },
            });

            // When dialog is closed, show the next notice
            dialogRef.afterClosed().subscribe((result) => {
                this.currentNoticeIndex++;
                if (result === 'marked') {
                    // If marked as read, add a small delay to allow toast to be seen
                    setTimeout(() => {
                        this.showNextNotice();
                    }, 20000);
                } else {
                    // If just closed, show next immediately
                    this.showNextNotice();
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.userIdleService.destroy();
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
